<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Swal },
    data() {
        return {
            title: "Evaluaciones coordinadores ",
            items: [
                {
                text: "Evaluaciones",
                href: "/"
                },
                {
                text: "Coordinadores",
                active: true
                }
            ],
            coordinadores:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            dato:{
                id:'',
                coordinador:'',
                mes_ano:'',
                p1:'Prepara la actividad de manera anticipada, considerando el volumen de estudiantes esperado o informado por el orientador, con el fin de evitar que algún estudiante no complete su ficha, no disponga de un ensayo u otros insumos necesarios.',
                r1:'',
                p2:'Mantiene una presentación personal acorde con el estándar institucional (uso de chaqueta) y con la actividad realizada. Asimismo, procura que sus laborantes cumplan con este estándar, proporcionando algún distintivo UDLA (lanyard, polerón, chaqueta, entre otros).',
                r2:'',
                p3:'Maneja el contenido de su presentación de manera adecuada, generando y fomentando el interés de los asistentes. Asimismo, se mantiene en constante actualización para entregar información pertinente y relevante para su público objetivo.',
                r3:'',
                p4:'Se desenvuelve en la actividad de manera empática con los estudiantes, generando espacios de interacción y resolución de dudas. Asimismo, demuestra empatía con los orientadores, posicionándose como un aliado en la resolución de necesidades planteadas por el establecimiento.',
                r4:'',
            },
            ordenEstado: null,
        };
    },
    computed:{
        rows() {
            return this.coordinadores.length;
        },
        filteredData() {
            // Filtramos los datos en base al campo 'filtro'
            let resultado = this.coordinadores.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
            if (this.ordenEstado) {
                resultado.sort((a, b) => {
                    const estadoA = a.fecha_respuesta == null ? 0 : 1;
                    const estadoB = b.fecha_respuesta == null ? 0 : 1;

                    return this.ordenEstado === 'asc'
                        ? estadoA - estadoB
                        : estadoB - estadoA;
                });
            }
            return resultado;
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
        mesEvaluacionActual() {
            const fecha = new Date();
            fecha.setDate(1);
            fecha.setMonth(fecha.getMonth() + 1);
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const ano = String(fecha.getFullYear());
            return mes + '-' + ano;
        },
        evaluacionEditable() {
            return this.dato.mes_ano === this.mesEvaluacionActual;
        },
    },
    methods:{
        showModal(item) {
            this.dato.coordinador = item.name;
            this.dato.id = item.id;
            this.dato.user_id = item.user_id;
            this.dato.mes_ano = item.mes_ano;
            this.dato.r1 = item.r1;
            this.dato.r2 = item.r2;
            this.dato.r3 = item.r3;
            this.dato.r4 = item.r4;
            this.$refs['modal-evaluar'].show()
        },
        mes_ano(mes_actual){
            const [mes, ano] = mes_actual.split('-');
            // Los registros se crean para el mes siguiente, -2 muestra el mes evaluado
            const fecha = new Date(ano, parseInt(mes, 10) - 2, 1);
            // Usar Intl.DateTimeFormat para obtener el nombre del mes en español
            const mesTexto = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(fecha);
            return mesTexto.charAt(0).toUpperCase() + mesTexto.slice(1);
        },
        responder(bvModalEvt){
            if (!this.evaluacionEditable) {
                if (bvModalEvt) {
                    bvModalEvt.preventDefault();
                }

                Swal.fire({
                    icon: 'info',
                    title: 'Edición no permitida',
                    text: 'Solo puedes editar evaluaciones del mes actual.'
                });

                return;
            }

            let formData = new FormData();
            formData.append('id', this.dato.id);
            formData.append('user_id', this.dato.user_id);
            formData.append('mes_ano', this.dato.mes_ano);
            formData.append('p1', this.dato.p1);
            formData.append('r1', this.dato.r1);
            formData.append('p2', this.dato.p2);
            formData.append('r2', this.dato.r2);
            formData.append('p3', this.dato.p3);
            formData.append('r3', this.dato.r3);
            formData.append('p4', this.dato.p4);
            formData.append('r4', this.dato.r4);
            axios.post('/api/guardar_evaluacion_coordinador',formData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'success',
                        title: 'Se ha guardado la evaluación',
                        //text: '',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    axios.get('/api/get_evaluaciones_coordinadores').then(res=>{
                        this.coordinadores=res.data.coordinadores.filter(c => c.user_id != this.user.id && c.user_id!='20')
                    });
                }
            }).catch(error => {
                if (bvModalEvt) {
                    bvModalEvt.preventDefault();
                }

                const mensaje = error && error.response && error.response.data && error.response.data.mensaje
                    ? error.response.data.mensaje
                    : 'No fue posible guardar la evaluación.';

                Swal.fire({
                    icon: 'error',
                    title: 'No se pudo guardar',
                    text: mensaje
                });
            });
        },
        esEditableItem(item) {
            return item.mes_ano === this.mesEvaluacionActual;
        },
        ordenarPorEstado() {
            if (this.ordenEstado === null) {
                this.ordenEstado = 'asc';
            } else if (this.ordenEstado === 'asc') {
                this.ordenEstado = 'desc';
            } else {
                this.ordenEstado = null;
            }
        }
    },
    created(){
        axios.get('/api/get_evaluaciones_coordinadores').then(res=>{
            this.coordinadores=res.data.coordinadores.filter(c => c.user_id != this.user.id && c.user_id!='20')

        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 10%;">Nº</th>
                                        <th style="width: 20%;">Nombre</th>
                                        <th style="width: 10%;">Rut</th>
                                        <th style="width: 20%;">Mes</th>
                                        <th style="width: 20%; cursor: pointer;" @click="ordenarPorEstado">
                                            Estado
                                            <span v-if="ordenEstado === 'asc'">▲</span>
                                            <span v-else-if="ordenEstado === 'desc'">▼</span>
                                        </th>
                                        <th style="width: 20%;">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ mes_ano(item.mes_ano) }}</td>
                                        <td :class="item.fecha_respuesta == null ? 'pill pill-sm rojo' : 'pill pill-sm verde'">{{ item.fecha_respuesta==null? 'No respondido':'Contestado' }}</td>
                                        <td>
                                            <b-button @click="showModal(item)" variant="primary">{{ esEditableItem(item) ? 'Evaluar' : 'Ver resultados' }}</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-evaluar" size="lg" :title="'Evaluar a '+this.dato.coordinador" ok-title="Guardar" cancel-title="Cancelar" :ok-disabled="!evaluacionEditable" @ok="responder">
                            <div class="row">
                                <div class="col-md-12 mb-2" v-if="!evaluacionEditable">
                                    <div class="alert alert-warning mb-0">
                                        Esta evaluación está en modo solo lectura. Solo el mes actual está habilitado.
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Preparación</label>
                                        <b-form-group label="Prepara la actividad de manera anticipada, considerando el volumen de estudiantes esperado o informado por el orientador, con el fin de evitar que algún estudiante no complete su ficha, no disponga de un ensayo u otros insumos necesarios." v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r1"
                                                        :disabled="!evaluacionEditable"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Presentación Personal</label>
                                        <b-form-group label="Mantiene una presentación personal acorde con el estándar institucional (uso de chaqueta) y con la actividad realizada. Asimismo, procura que sus laborantes cumplan con este estándar, proporcionando algún distintivo UDLA (lanyard, polerón, chaqueta, entre otros)." v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r2"
                                                        :disabled="!evaluacionEditable"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Contenido</label>
                                        <b-form-group label="Maneja el contenido de su presentación de manera adecuada, generando y fomentando el interés de los asistentes. Asimismo, se mantiene en constante actualización para entregar información pertinente y relevante para su público objetivo." v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r3"
                                                        :disabled="!evaluacionEditable"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <label>Habilidades</label>
                                        <b-form-group label="Se desenvuelve en la actividad de manera empática con los estudiantes, generando espacios de interacción y resolución de dudas. Asimismo, demuestra empatía con los orientadores, posicionándose como un aliado en la resolución de necesidades planteadas por el establecimiento." v-slot="{ ariaDescribedby }" >
                                            <div class="row mt-3 text-center">
                                                <div class="offset-md-1 col-md-3 text-right">
                                                    <p class="mt-2">En desacuerdo</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <b-form-radio-group
                                                        id="btn-radios-1"
                                                        v-model="dato.r4"
                                                        :disabled="!evaluacionEditable"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="radios-btn-default"
                                                        buttons
                                                        button-variant="warning"
                                                        >
                                                            <b-form-radio value="1">1</b-form-radio>
                                                            <b-form-radio value="2">2</b-form-radio>
                                                            <b-form-radio value="3">3</b-form-radio>
                                                            <b-form-radio value="4">4</b-form-radio>
                                                            <b-form-radio value="5">5</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-3 text-left">
                                                    <p class="mt-2">Muy de acuerdo</p>
                                                </div>
                                            </div>
                                        </b-form-group>
                                    </b-card>
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style>
.pill {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  text-align: center;
}
.pill-sm {
  padding: 2px 8px;
  font-size: 10px;
}
.rojo {
  background-color: #e3342f; /* Rojo fuerte */
}
.verde {
  background-color: #38c172; /* Verde bonito */
}
</style>
